export const SCAM_PAC_CARDS = [
  {
    number: 1,
    color: 'red',
    title: 'Outrageous Fundraising Costs',
    text: 'A normal PAC might spend up to 20% of their budget on fundraising. But scam PACs spend 65%+ on raising more.',
  },
  {
    number: 2,
    color: 'blue',
    title: 'Self-Dealing',
    text: 'The worst scam PACs spend large sums of donations on firms owned by PAC leaders, driving personal profit.',
  },
  {
    number: 3,
    color: 'red',
    title: 'Sketchy Solicitations',
    text: 'It is a scary time for our country but that is no excuse for fear mongering or misleading donation solicitations.',
  },
];
